import React from 'react';
import { ContentfulHeroBlock } from '@jbhi-fi/apis/src/contentful/types';
import { CardTransformer } from './CardTransformer';
import { HeroBlockHeading, HeroBlockHeadingProps, HeroBlockProps } from '../../HeroBlock';
import { CardGridCardProps } from '../../ContentCard/CardGrid/CardGrid';
import { ContentCardCoverImage } from '../../ContentCard';
import { LaunchTiles, LaunchTilesProps } from '../../LaunchTiles/LaunchTiles';
import { breakpointSizePx } from '@jbhi-fi/lanyard-ui/themes';

export type ContentfulApiHeroBlockToHeroBlockPropsOptions = {
  launchTilesProps?: LaunchTilesProps;
  heroBlockHeadingProps?: HeroBlockHeadingProps;
  heroBlockCta?: React.ReactNode;
  showTags?: boolean;
  testId?: string;
};

export abstract class HeroBlockTransformer {
  static toHeroBlockProps = (
    entry: ContentfulHeroBlock,
    options: ContentfulApiHeroBlockToHeroBlockPropsOptions = {}
  ): HeroBlockProps => {
    const { fields } = entry ?? {};
    const { launchTilesProps, heroBlockHeadingProps, heroBlockCta, showTags = true } = options;
    const breakToCarousel = fields?.mobilePresentation === 'Slide';

    return {
      testId: options.testId,
      heading: heroBlockHeadingProps ? <HeroBlockHeading {...heroBlockHeadingProps} /> : null,
      breakToCarousel,
      launchTiles: launchTilesProps ? <LaunchTiles {...launchTilesProps} /> : null,
      footer: heroBlockCta,
      cards: fields?.cards
        ?.map((card, i) => {
          if (!card?.fields) return null;
          const baseCardProps = CardTransformer.toCardProps(card);

          return {
            ...baseCardProps,
            width: breakToCarousel ? { xs: '345px', md: '100%' } : baseCardProps.width,
            showTag: showTags,
            maxContentLines: 2,
            headingSize: 'small',
            cover: !baseCardProps.isFixedHeight ? (
              <ContentCardCoverImage
                {...{
                  ...CardTransformer.toCardCoverImageProps(card),
                  sizes: `(max-width: ${breakpointSizePx.md}px) ${breakToCarousel ? '345px' : '100vw'}, ${
                    i === 0 ? '700px' : '350px'
                  }`,
                }}
              />
            ) : (
              baseCardProps.cover
            ),
          } satisfies CardGridCardProps;
        })
        ?.filter(Boolean) as Array<CardGridCardProps>,
    };
  };
}
